export const parseTime = time => {
  if (time) {
    return time.split(' ')[0]
  }

  return ''
}
